module.exports = __webpack_public_path__ + "img/4.1246652c.png";